import logo from '@/assets/logo_red2.jpg';
import { cn } from '@packages/utils';

type Props = {
  className?: string;
};

export const Logo = ({ className }: Props) => {
  return (
    <div className={cn('p-6 bg-primary', className)}>
      <img src={logo} />
    </div>
  );
};
